import React from "react";
import ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import SponsorsWidget from "./SponsorsWidget";
import SpeakersWidget from "./SpeakersWidget";
import ProgramWidget from "./ProgramWidget";
import RegisterWidget from "./RegisterWidget";
import enMessages from "./locales/en.json";
import trMessages from "./locales/tr.json";
import { Provider } from "react-redux";
import { store } from "./store";

import "./widget.scss";
import FaqWidget from "./FaqWidget";
import PhotoAlbumWidget from "./PhotoAlbumWidget";
import AreaMapsWidget from "./AreaMapsWidget";

const messages = {
	en: enMessages,
	tr: trMessages,
};

class KapitalEventsWidgetElement extends HTMLElement {
	connectedCallback() {
		const resource = this.getAttribute("resource");
		const language = this.getAttribute("language");
		const rowHeight = this.getAttribute("rowHeight");
		const photoAlbumID = this.getAttribute("photoAlbumID");
		const eventID = this.getAttribute("eventID");
		const organiserID = this.getAttribute("organiserID");
		const color = this.getAttribute("color") || "#fff";
		const headerTitle = this.getAttribute("headerTitle") || "";
		const formID = this.getAttribute("formID") || "";
		const grid = this.getAttribute("grid") || 5;
		const view = this.getAttribute("view") || "box";
		const topics = this.getAttribute("topics") || "";
		const limit = this.getAttribute("limit") || "";
		const programDayTopic = this.getAttribute("programDayTopic") || "";
		const imageType = this.getAttribute("imageType") || "square";

		// true/false alan attribute'lar: sadece "true" yazılmışsa açık kabul edilir.
		// Attribute hiç yazılmamışsa ya da "false" ise kapalıdır.
		const isEnabled = (name) => this.getAttribute(name) === "true";
		const displayTitle = isEnabled("displayTitle");
		const displaySearch = isEnabled("displaySearch");
		const autoOpen = isEnabled("autoOpen");
		const speakerSharingEnabled = isEnabled("speakerSharingEnabled");
		const defaultShowAll = isEnabled("defaultShowAll");
		const headerImage = isEnabled("headerImage");
		const footerImage = isEnabled("footerImage");

		const root = ReactDOM.createRoot(this);
		root.render(
			<Provider store={store}>
				<IntlProvider locale={language} messages={messages[language]}>
					{resource === "register" && (
						<RegisterWidget
							language={language}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							formID={formID}
							grid={grid}
							view={view}
							headerImage={headerImage}
							footerImage={footerImage}
						/>
					)}
					{resource === "program" && (
						<ProgramWidget
							language={language}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							headerTitle={headerTitle}
							defaultShowAll={defaultShowAll}
							topics={topics}
							programDayTopic={programDayTopic}
						/>
					)}
					{resource === "speakers" && (
						<SpeakersWidget
							language={language}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							headerTitle={headerTitle}
							displaySearch={displaySearch}
							autoOpen={autoOpen}
							speakerSharingEnabled={speakerSharingEnabled}
							topics={topics}
							limit={limit}
							imageType={imageType}
							grid={grid}
						/>
					)}
					{resource === "sponsors" && (
						<SponsorsWidget
							language={language}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							headerTitle={headerTitle}
						/>
					)}
					{resource === "faq" && (
						<FaqWidget
							language={language}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							headerTitle={headerTitle}
						/>
					)}
					{resource === "photoAlbum" && (
						<PhotoAlbumWidget
							language={language}
							photoAlbumID={photoAlbumID}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							headerTitle={headerTitle}
							rowHeight={rowHeight}
						/>
					)}
					{resource === "areaMap" && (
						<AreaMapsWidget
							language={language}
							eventID={eventID}
							organiserID={organiserID}
							color={color}
							displayTitle={displayTitle}
							headerTitle={headerTitle}
							grid={grid}
						/>
					)}
				</IntlProvider>
			</Provider>
		);
	}
}

if (!customElements.get("kapital-events-widget"))
	customElements.define("kapital-events-widget", KapitalEventsWidgetElement);
